<template>
  <div class="bb-kpi-transfer">
    <div class="bb-form">
      <div class="bb-form-item">
        <label class="bb-kpi-transfer__label bb-form__label">
          User
        </label>
        <custom-select :list="users"
                       :table-mode="true"
                       styles="short"
                       class="bb-kpi-transfer__select"
                       @setValue="setUser"/>
      </div>
      <div class="bb-form-item">
        <label class="bb-kpi-transfer__label bb-form__label">
          Service
        </label>
        <custom-select :list="servicesWithValue"
                       :table-mode="true"
                       styles="short"
                       class="bb-kpi-transfer__select"
                       @setValue="setService"/>
      </div>
      <div class="bb-form-item">
        <label class="bb-kpi-transfer__label bb-form__label" for="amount">
          Amount
        </label>
        <div class="bb-kpi-transfer__amount">
          <input class="bb-input bb-input_border bb-kpi-transfer__input"
                 :class="{'bb-input_error': invalidAmount}"
                 type="text"
                 id="amount"
                 v-autofocus
                 ref="inputAmount"
                 autocomplete="off"
                 @focus="focusInput()"
                 v-model="amount"
                 @keyup.enter="setTransfer"
                 @change="errorAmount = false"
                 @input="invalidAmount = false">
          <span class="bb-kpi-transfer__max"
                :class="{'bb-kpi-transfer__max_error': errorAmount}">
          Max {{service.approvedValue ? convertNumber(service.approvedValue) : '0.00'}}
        </span>
        </div>
      </div>
    </div>
    <div @click="setTransfer" class="bb-kpi-transfer__button">
      <slot/>
    </div>
  </div>
</template>

<script>
import CustomSelect from '@/components/Main/Inputs/CustomSelect'
import convertNumber from '@/mixin/convertNumber'
import validateNum from '@/mixin/validateNum'
import _ from 'lodash'

export default {
  name: 'TransferKPI',
  props: ['fromUser', 'list'],
  mixins: [convertNumber, validateNum],
  components: {
    CustomSelect
  },
  data () {
    return {
      servicesWithValue: [],
      service: {},
      errorAmount: false,
      invalidAmount: false,
      amount: 0,
      transfer: {
        sourceUser: this.fromUser._id,
        destinationUser: ''
      }
    }
  },
  computed: {
    users () {
      const users = _.filter(this.$store.getters.usersList, item => {
        const deptUserTo = _.get(item, 'position', false)
        return item.id !== this.fromUser._id && deptUserTo
      })
      const groupUsers = _.groupBy(users, 'isNotAssigned')
      const isNotAssigned = groupUsers.true || []
      const sortedUsers = _.orderBy(groupUsers.false, [item => item.firstName.toLowerCase()], ['asc'])
      return [...sortedUsers, ...isNotAssigned]
    }
  },
  methods: {
    focusInput () {
      if (!this.validateNum(this.amount)) {
        this.amount = ''
      }
    },
    checkAmountTransfer () {
      const maxAmount = this.service.approvedValue
      if (maxAmount < this.amount) {
        this.errorAmount = 'earned: ' + this.convertNumber(maxAmount)
      }
      return maxAmount >= this.amount
    },
    checkInputs () {
      this.amount = this.validateNum(this.amount)
      if (!this.amount || this.amount < 0.01 || !this.checkAmountTransfer()) {
        this.invalidAmount = true
        this.$refs.inputAmount.focus()
        return false
      }
      this.invalidAmount = false
      return true
    },
    setUser (item) {
      this.transfer.destinationUser = item.id
    },
    setService (item) {
      this.service = item
      this.transfer.invoiceId = item.invoice.id
      this.transfer.userKpiId = item._id
      this.transfer.isDouble = item.isDouble
      this.transfer.doubleId = item.doubleId
    },
    setTransfer () {
      if (this.checkInputs()) {
        this.transfer.transferValue = this.amount
        this.$emit('setTransfer', this.transfer)
      }
    }
  },
  beforeMount () {
    this.servicesWithValue = _.filter(this.list, item => item.amount > 0 && !item.isRollbackKpi)
      .map((item) => {
        item.name = `${item.client.name} - ${item.service.name} `
        return item
      })
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bb-kpi-transfer {
    min-width: 400px;

    &__amount {
      width: 100%;
    }

    &__max {
      color: $color-silver-chalice;
      font-size: 11px;
      margin: 3px 0 12px;
      transition: .2s;

      &_error {
        color: $color-red-orange;
      }
    }

    &__label {
      min-width: 57px;
    }

    &__button {
      margin: 28px auto 0;
      width: 117px;
    }

    &__select {
      font-weight: 300;
      font-size: 12px;
      line-height: 14px;
      height: 30px;
    }

    &__input {
      width: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Finance/KPI/TrasferKPI/TransferKPI.vue